import {
  COMPONENT_VALUE_TYPES as types,
  PERCENTAGES,
  BACKGROUND_IMAGE_POSITION,
  COMPONENT_COLOR_THEMES,
} from 'shared/constants';

const propsSchema = [
  {
    key: 'theme',
    label: 'Theme',
    type: types.ENUM,
    options: COMPONENT_COLOR_THEMES
  },
  {
    key: 'left_column',
    label: 'Left Column',
    type: types.OBJECT,
    children: [
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT
      },
      {
        key: 'description',
        label: 'Description',
        type: types.TEXT
      }
    ]
  },
  {
    key: 'right_column',
    label: 'Right Column',
    type: types.OBJECT,
    children: [
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT
      },
      {
        key: 'description',
        label: 'Description',
        type: types.TEXT
      }
    ]
  },
  {
    key: 'bg_img',
    label: 'Background Image',
    type: types.OBJECT,
    children: [
      {
        key: 'url',
        label: 'Url',
        type: types.TEXT
      },
      {
        key: 'dark_overlay',
        label: 'Dark Overlay',
        type: types.ENUM,
        options: PERCENTAGES
      },
      {
        key: 'position',
        label: 'Background Position',
        type: types.ENUM,
        options: BACKGROUND_IMAGE_POSITION
      }
    ]
  },
  {
    key: 'hide_mobile',
    label: 'Hide text on Mobile',
    type: types.BOOLEAN
  },
  {
    key: 'additional_height',
    label: 'Additional Height % (Ex. for 110% select 10)',
    type: types.ENUM,
    options: PERCENTAGES
  }
];

const defaultProps = {
  theme: 'DARK',
  left_column: {
    title: 'We Seek the Best',
    description: 'At FF, we seek ambitious, imaginative professionals who are motivated to become part of an entrepreneurial workforce that values action over bureaucracy. We embrace those who want to make a meaningful contribution to the future of global mobility, and who are eager to experiment tirelessly to make that change happen today.'
  },
  right_column: {
    title: 'We Return the Favor',
    description: 'We are a dynamic and rapidly growing company with excellent benefits. Besides the usual (competitive salaries and generous healthcare benefits), you can look forward to catered lunches, social events, and, most importantly, the chance to unleash all your great ideas in an open and collaborative environment. We also offer significant equity packages, which means we are all owners in the company.'
  },
  bg_img: {
    url: 'https://genesis-cdn.ff.com/our_company/03_careers/career-intro.jpg',
    dark_overlay: '0',
    position: 'CENTER CENTER'
  },
  hide_mobile: true,
  additional_height: 0
};

export default {
  title: 'Double Head',
  id: 'DoubleHead',
  propsSchema,
  defaultProps
};
